import React, { useState, useEffect, useContext } from 'react';
import UserContext from '../context/user/UserContext';
import StateContext from '../context/state/StateContext';
import styles from '../styles/group.module.css'
import { toast } from 'react-toastify';

const Group = () => {
  const { user, getEmployees } = useContext(UserContext);

  const { setModal, token, groups, setGroups, setConfirm } = useContext(StateContext);
  const url = process.env.REACT_APP_API_URL + "api/group/";

  async function getGroups() {
    const response = await fetch(`${url}get`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'auth-token': `${token}`
      }
    });
    const result = await response.json();
    if (result.success) {
      setGroups(result.groups);
    }
  }

  useEffect(() => {
    getEmployees(); // Fetch employees via context function
    getGroups();
  }, []);

  return (
    <>
      <div className="container-fluid px-0 overflow-hidden">
        <div className="heading">
          <h3>Your Groups</h3>
          {user.role == "admin" || user.role == "hod" ?
            <div className='btn-div' onClick={() => setModal({ open: true, component: "Group" })}>
              <button className='learn-more' id='add'>
                <span className='circle' aria-hidden="true">
                  <span className='icon arrow'></span>
                </span>
                <span className='button-text'>Add Group</span>
              </button>
            </div>
            : null}
        </div>

        <div className={styles.groupsContainer}>
          {groups && groups.length > 0 ? groups.map((group) => (
            <div key={group.id} className={styles.groupCard}>
              <div className={styles.groupHeader}>
                <h2 className={styles.groupName}>{group.name}</h2>
                {user.role === "admin" || user.role === "hod" ? 
                  <button
                    className={styles.deleteButton}
                    onClick={() => {
                      setModal({ open: true, component: "Confirm" });
                      setConfirm({
                        component: "Group",
                        ticketId: group.id, // Corrected from ticketId to groupId since it's a group
                        text: "Are you sure you want to delete this group?"
                      });
                    }}
                  >
                    Delete
                  </button>
                  : null}

              </div>
              <ul className={styles.userList}>
                {group.users && group.users.length > 0 ? (
                  group.users.map((user, index) => (
                    <li key={index} className={styles.userItem}>
                      {user.name}
                    </li>
                  ))
                ) : (
                  <li className={styles.noUsers}>No users in this group</li>
                )}
              </ul>
            </div>
          )) : <p>No groups available.</p>}
        </div>
      </div>
    </>
  );
};

export default Group;
